import ArticleGrid from './ArticleGrid'

export default ArticleGrid
